import { ButtonLabel } from 'components/Button';
import { Icon } from 'components/Icon';
import moment from 'moment';
import 'moment/locale/ru';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import DayPicker, { DateUtils } from 'react-day-picker';
import 'react-day-picker/lib/style.css';
import MomentLocaleUtils from 'react-day-picker/moment';
import InputMask from 'react-input-mask';
import { useFirstRender } from 'hooks/useFirstRender';

export const RangeDatePicker = ({ handleFilter, close, boxShadow }) => {
  const [from, setFrom] = useState(undefined);
  const [to, setTo] = useState(undefined);

  const firstRender = useFirstRender();
  const classNames = ['range-date'];

  if (boxShadow) {
    classNames.push('box-shadow');
  }

  useEffect(() => {
    if (firstRender) return;
    if (from && to) {
      const fromTransformed = new Date(from);
      const toTransformed = new Date(to);
      fromTransformed.setHours(0, 0, 1);
      toTransformed.setHours(23, 59, 59);
      handleFilter({ from: fromTransformed, to: toTransformed });
    } else if (!from && !to) {
      handleFilter();
    }
  }, [from, to]);

  const handleFromChange = ({ target: { value } }) => {
    const date = moment(value, 'DD.MM.YYYY', true);
    if (date.isValid()) {
      setFrom(date.toDate());
    }
  };

  const handleToChange = ({ target: { value } }) => {
    const date = moment(value, 'DD.MM.YYYY', true);
    if (date.isValid()) {
      setTo(date.toDate());
    }
  };

  const handleDayClick = (day) => {
    if (from && to) {
      setFrom(day);
      setTo(undefined);
    } else {
      const range = DateUtils.addDayToRange(day, { from, to });
      setFrom(range.from);
      setTo(range.to);
    }
  };

  const handleResetDates = () => {
    setFrom(undefined);
    setTo(undefined);
    close();
  };

  const modifiers = { start: from, end: to };

  return (
    <div className={classNames.join(' ')}>
      <div className="inputs-wrapper">
        <InputMask mask="99.99.9999" value={from ? moment(from).format('DD.MM.YYYY') : ''} onChange={handleFromChange}>
          {(inputProps) => (
            <div className="input-wrapper">
              <input {...inputProps} type="text" placeholder="__.__.____" />
              <Icon name="calendar" />
            </div>
          )}
        </InputMask>
        <span className="delimiter">по</span>
        <InputMask mask="99.99.9999" value={to ? moment(to).format('DD.MM.YYYY') : ''} onChange={handleToChange}>
          {(inputProps) => (
            <div className="input-wrapper">
              <input {...inputProps} type="text" placeholder="__.__.____" />
              <Icon name="calendar" />
            </div>
          )}
        </InputMask>
      </div>
      <DayPicker
        className="Selectable"
        localeUtils={MomentLocaleUtils}
        locale="ru"
        disabledDays={{ before: from }}
        selectedDays={[from, { from, to }]}
        modifiers={modifiers}
        onDayClick={handleDayClick}
      />
      {from && to && <ButtonLabel rounded={true} onClick={handleResetDates} text="Очистить фильтр" />}
    </div>
  );
};

RangeDatePicker.propTypes = {
  handleFilter: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
  boxShadow: PropTypes.bool,
};

RangeDatePicker.defaultProps = {
  boxShadow: true,
};
